<template>
    <nav class="navbar navbar-light bg-light p-2">
        <span class="navbar-brand mb-0 h1">ContactWeb Administrace</span>
        <a class="navbar-text" href="Javascript:void(0);" @click="logout">Odhlásit se</a>
    </nav>
</template>
<script>
export default {
    name: "NavComponent",
    methods: {
        logout() {
            localStorage.removeItem("token");
            this.$router.push("/login");
        },
    },
};
</script>
